export default {
    email: '',
    salutation: '',
    password: '',
    password_confirmation: '',
    first_name: '',
    last_name: '',
    language: '',
    accepted_terms: '',
    user: {
        home_country: '',
        home_house_number: '',
        home_house_name: '',
        home_city: '',
        home_street: '',
        home_state: '',
        home_postcode: ''
    },
    experience: '',
    mobile: '',
    country_of_residence: '',
    payment: {}
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Marketing/helpers/keys.js